export default __webpack_public_path__ + "static/media/notfound.2fc34122.svg";